<!-- A day as dd.mm.yyyy, in every browser (see ./dates.js for why not the
     browser's own date field). Typed — 8.10.26 will do — or picked from
     Vuetify's calendar, which is in Estonian with Monday first.

     The value is 'YYYY-MM-DD' both ways, as the native field's was, and an
     emptied field is ''. Something typed that is not a day goes back to the
     last good one on blur.

     Two looks: a Vuetify text field (every attribute passes through to it),
     or `plain`, a bare <input> for the new-look pages, which takes the page's
     own class. -->
<template>
  <v-menu v-model="open" :close-on-content-click="false" location="bottom start" min-width="290">
    <template #activator="{ props: menu }">
      <span v-if="plain" class="df-plain" :class="{ 'df-plain--block': block }">
        <input
          :value="draft"
          type="text"
          inputmode="numeric"
          autocomplete="off"
          placeholder="pp.kk.aaaa"
          :disabled="disabled"
          v-bind="$attrs"
          @input="draft = $event.target.value"
          @blur="commit"
          @keydown.enter.prevent="commit"
        >
        <button type="button" class="df-plain__pick" :disabled="disabled" aria-label="Vali kalendrist" v-bind="menu">
          <v-icon size="18">mdi-calendar</v-icon>
        </button>
      </span>
      <v-text-field
        v-else
        :model-value="draft"
        :disabled="disabled"
        placeholder="pp.kk.aaaa"
        inputmode="numeric"
        autocomplete="off"
        v-bind="$attrs"
        @update:model-value="draft = $event || ''"
        @blur="commit"
        @keydown.enter.prevent="commit"
        @click:clear="clear"
      >
        <template #append-inner>
          <v-icon v-bind="menu" aria-label="Vali kalendrist" role="button" tabindex="-1">mdi-calendar</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      :model-value="pickerDate"
      color="primary"
      show-adjacent-months
      hide-header
      @update:model-value="pick"
    />
  </v-menu>
</template>

<script>
import dayjs from 'dayjs'
import { parseDate, showDate } from './dates'

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: '' },
    plain: Boolean,
    // The plain input fills its row (a form field) instead of sitting inline.
    block: Boolean,
    // Undefined unless set, so a disabled v-form still disables it: an
    // explicit false would override the form.
    disabled: { type: Boolean, default: undefined }
  },
  emits: ['update:modelValue'],
  data () {
    return { draft: showDate(this.modelValue), open: false }
  },
  computed: {
    pickerDate () {
      return this.modelValue ? dayjs(this.modelValue).toDate() : undefined
    }
  },
  watch: {
    modelValue (value) {
      this.draft = showDate(value)
    }
  },
  methods: {
    commit () {
      if (!String(this.draft).trim()) return this.clear()
      const iso = parseDate(this.draft)
      if (iso && iso !== this.modelValue) this.$emit('update:modelValue', iso)
      this.draft = showDate(iso || this.modelValue)
    },
    clear () {
      this.draft = ''
      if (this.modelValue) this.$emit('update:modelValue', '')
    },
    pick (date) {
      this.open = false
      if (date) this.$emit('update:modelValue', dayjs(date).format('YYYY-MM-DD'))
    }
  }
}
</script>

<style scoped>
.df-plain { position: relative; display: inline-flex; align-items: center; min-width: 0; }
.df-plain--block { display: flex; width: 100%; }
.df-plain input { width: 100%; padding-right: 34px; }
.df-plain__pick { position: absolute; right: 4px; top: 50%; transform: translateY(-50%); border: 0; background: none; padding: 4px; cursor: pointer; color: inherit; opacity: .7; line-height: 0; border-radius: 6px; }
.df-plain__pick:hover { opacity: 1; }
.df-plain__pick:disabled { cursor: default; opacity: .35; }
</style>
